import { Directive } from '@angular/core';

@Directive({
  selector: '[appListSelectGroupInnerItem]'
})
export class ListSelectGroupInnerItemDirective {}
